'use strict'

import { orderBy } from 'lodash';

import { loadComponent } from './utils/load-component';
import { getPackage } from '../services/package';
import { getEventData } from '../services/inventory';
import zonedDate from '../utils/zoned-date';

loadComponent('package-panel-list', {
    props: {
        packageNo: {
            type: Number,
        },
    },
    data() {
        return {
            ViewModel: {
                Loading: true,
                Events: [],
            },
        };
    },
    beforeMount() {
        Promise.all([ getPackage(this.packageNo), getEventData() ]).then(responses => {
            const [ packageResponse, eventsResponse ] = responses;

            if (packageResponse) {
                const events = eventsResponse.filter(event => {
                    return packageResponse.Performances.some(details => {
                        return parseInt(details.Id, 10) === parseInt(event.PerformanceNumber, 10);
                    });
                });

                this.ViewModel.Events = orderBy(events, item => zonedDate(item.PerformanceDate), 'asc');
            }
        }).finally(() => {
            this.ViewModel.Loading = false;
        });
    },
});
